<template>
  <dashboard-layout> </dashboard-layout>
</template>

<script>
export default {
  name: 'home',
  mounted() {
    this.$router.push({ name: 'art-club' });
  },
};
</script>
